<template>
  <div class="controls-wrapper">
    <icon-button icon="el-icon-close" v-if="leftControl" @click="removeCurrency"/>
    <icon-button icon="el-icon-edit"  v-else @click="showDialog = true" />

    <el-dialog :append-to-body="true" v-if="showDialog" append-to-body width="400px" title="Edit currency" :visible.sync="showDialog">
      <upsert-form v-if="showDialog" :currency="currency" @update="update" />
    </el-dialog>

  </div>
</template>

<script>
import UpsertForm from './UpsertForm'

export default {
  name: 'CurrencyControls',
  components: { UpsertForm },
  props: {
    currency: {
      type: Object,
      required: true
    },
    leftControl: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    update (updatedCurrency) {
      this.showDialog = false
      this.$emit('update', this.currency, updatedCurrency)
    },
    async removeCurrency () {
      const response = await this.$http.delete(this.$api.currencies.delete(this.currency.id))
      this.$message.success('Currency deleted')
      this.$emit('remove', this.currency)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/currencies/CurrencyControls.vue